module.exports = {"440306001":"新安街道","440306002":"光明","440306003":"西乡街道","440306004":"福永街道","440306005":"沙井街道","440306006":"松岗街道","440306007":"公明","440306008":"石岩街道","440306011":"大浪","440306012":"龙华","440306013":"民治","440306014":"观湖","440306015":"福城","440306016":"观澜","440306400":"深圳市宝安国际机场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440306.json
// module id = 1798
// module chunks = 0